<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <h2>同時に予約・利用できるのは1台まで</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>
<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";
export default {
  name: "DialogAlreadyReserved",
  setup() {
    const dialogRef = ref(null);
    const openDialog = () => {
      dialogRef.value.open();
    };
    const closeDialog = () => {
      dialogRef.value.close();
    };
    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
